import { createContext, useContext, useState } from 'react';

const ReportAttendanceOperatorDetailContext = createContext();

const initialState = {
  selectedTab: 'restViolation',
  isOpenDetailModal: false,
  isOpenImagePreview: false,
  selectedImagePreview: [],
};

const initialFilterState = {
  page: 1,
  limit: 10,
  date: null,
};

const ReportAttendanceOperatorDetailProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return (
    <ReportAttendanceOperatorDetailContext.Provider value={{ updateState, ...state, updateFilterState, filterState }}>
      {children}
    </ReportAttendanceOperatorDetailContext.Provider>
  );
};

export const useReportAttendanceOperatorDetailState = () => {
  return useContext(ReportAttendanceOperatorDetailContext);
};

export default ReportAttendanceOperatorDetailProvider;
